import {
  NormalBrowseFileInputFiled,
  NormalTextEditorInputFiled,
  NormalTextInputField,
  RepeatableMultipleInputStackFilds,
} from "@/components";
import React, { useMemo } from "react";

const AmlCTFRulesRegulationsInputFilds = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleTextEditorInputChange,
  handleImageChange,
  addMultiValueRepeaterChange,
  removeMultiValueRepeaterChange,
  updateMultiValueRepeaterChange,
  adminRole,
  permissionsList,
  colorGrade,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {/* Text Content Section */}
      {selectedTab === "section-1" && (
        <>
          {/* Banner Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Banner Image"
              fieldId="aml-or-ctf-laws-banner-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("aml-or-ctf-laws-banner-image", id)
                  : handleImageChange("aml-or-ctf-laws-banner-image", "")
              }
              selectedFileId={formData?.["aml-or-ctf-laws-banner-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Banner Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Banner Heading"
            fieldId="aml-or-ctf-laws-banner-heading"
            fieldName="aml-or-ctf-laws-banner-heading"
            placeholderText="Banner Heading"
            inputValue={formData?.["aml-or-ctf-laws-banner-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Banner Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Banner Description"
            fieldId="aml-or-ctf-laws-banner-description"
            fieldName="aml-or-ctf-laws-banner-description"
            placeholderText="Banner Description"
            inputValue={formData?.["aml-or-ctf-laws-banner-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* DOCS Content */}
          <NormalTextEditorInputFiled
            isFetching={isFetching}
            labelText="Document Content"
            fieldId="aml-or-ctf-laws-docs-content"
            fieldName="aml-or-ctf-laws-docs-content"
            placeholderText="Documents Content"
            inputValue={formData?.["aml-or-ctf-laws-docs-content"] || ""}
            onChangeTextEditorFiled={handleTextEditorInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}

      {/* Downloads Section */}
      {selectedTab === "section-2" && (
        <>
          {/* Table Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Table Heading"
            fieldId="aml-downloads-table-heading"
            fieldName="aml-downloads-table-heading"
            placeholderText="Table Heading"
            inputValue={formData?.["aml-downloads-table-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Download Button Label */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Download Button Label"
            fieldId="aml-downloads-button-label"
            fieldName="aml-downloads-button-label"
            placeholderText="Download Button Label"
            inputValue={formData?.["aml-downloads-button-label"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Link Button Label */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Link Button Label"
            fieldId="aml-downloads-link-button-label"
            fieldName="aml-downloads-link-button-label"
            placeholderText="Link Button Label"
            inputValue={formData?.["aml-downloads-link-button-label"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Multi Downloads */}
          <RepeatableMultipleInputStackFilds
            stateDetails={formData}
            isFetching={isFetching}
            allFilesResponse={allFilesResponse}
            labelText="Download Content"
            fieldId="aml-downloads-content"
            fieldKey="aml-downloads-content"
            searchValue={searchValue}
            selectedFileType={selectedFileType}
            adminRole={adminRole}
            permissionsList={permissionsList}
            addMultiValueRepeaterChange={addMultiValueRepeaterChange}
            removeMultiValueRepeaterChange={removeMultiValueRepeaterChange}
            updateMultiValueRepeaterChange={updateMultiValueRepeaterChange}
            translateField={true}
            extraContainerClasses="mt-5"
            filedStructure={["TEXT", "IMAGE", "TEXT"]}
            dataStructure={{ label: "", value: "", fullUrl: "" }}
            placeholderTexts={["Label Text", "", "URL"]}
            hideStatus={[true, isHideInOtherLanguages, isHideInOtherLanguages]}
            extraInfos={[
              "",
              "",
              "Provide full URL if you don't want to use file to upload.",
            ]}
            colorGrade={colorGrade}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default AmlCTFRulesRegulationsInputFilds;
